module.exports = __webpack_public_path__ + "static/media/rating.96b3bd08.svg";